export const servicesSectionsText = {
  id: "services",
  title: "Våra",
  highlitedText: "Tjänster",
  subtext:
    "Vi hjälper företag att lyckas online med skräddarsydda webbplatser, appar och digitala lösningar. Modern design, snabb prestanda och smarta funktioner – vi har allt du behöver.",
  CTA: "Boka en gratis konsultation",
}

export const servicesDetails = [
  {
    id: "webbutveckling",
    title: "Webbutveckling – Hemsidor som konverterar",
    description: "Professionell och mobilanpassad webbutveckling för företag som vill växa online.",
    services: [
      {
        icon: "FiGlobe",
        title: "Responsiva & moderna hemsidor",
        description: "Anpassade hemsidor som ser bra ut och fungerar perfekt på alla enheter.",
      },
      {
        icon: "FiTrendingUp",
        title: "SEO-optimering för Google",
        description: "Bättre synlighet och fler kunder genom smart sökmotoroptimering.",
      },
      {
        icon: "FiCheckCircle",
        title: "Snabb & säker drift",
        description: "Vi ser till att din hemsida laddar blixtsnabbt och skyddas från hot.",
      },
    ],
  },
  {
    id: "apputveckling",
    title: "Apputveckling – iOS & Android",
    description: "Smarta, skalbara appar för ditt företag.",
    services: [
      {
        icon: "FiSmartphone",
        title: "Native & hybrid-appar",
        description: "Utveckling av appar för både iOS och Android – native eller med React Native.",
      },
      {
        icon: "FiCode",
        title: "API & dataintegration",
        description: "Koppla din app till externa system och datakällor för full funktionalitet.",
      },
      {
        icon: "FiUsers",
        title: "Engagerande UX & UI",
        description: "Vi skapar intuitiva appar som användare älskar att använda.",
      },
    ],
  },
  {
    id: "trovärdighet",
    title: "Varför välja oss?",
    description: "Vi levererar moderna digitala lösningar som är optimerade för tillväxt och prestanda.",
    services: [
      {
        icon: "FiShield",
        title: "5+ års erfarenhet",
        description: "Vi har byggt skräddarsydda webb- och applösningar för startups och småföretag.",
      },
      {
        icon: "FiUsers",
        title: "Fokus på användarupplevelse",
        description: "Vi skapar lösningar med modern UX och intuitiv design för bättre kundengagemang.",
      },
      {
        icon: "FiTrendingUp",
        title: "SEO & prestandaoptimerade",
        description: "Våra webbplatser är snabba, sökmotoroptimerade och anpassade för att konvertera.",
      },
    ],
  },
]
